module.exports = __webpack_public_path__ + "img/Homework.bb46b176.svg";